import {HttpClient} from '@angular/common/http';
import {Injectable, InjectionToken, inject} from '@angular/core';
import {TransferredLog, TransferredLogLevel} from '@scalified-monorepo/shared';
import {EMPTY} from 'rxjs';
import {catchError} from 'rxjs/operators';

export interface LoggerConfig {
  url?: string;
  envName?: string;
  appName?: string;
}

export const LOGGER_CONFIG = new InjectionToken<LoggerConfig>('LOGGER_CONFIG');

@Injectable({providedIn: 'root'})
export class LoggerTransferService {
  private http = inject(HttpClient);
  private config = inject(LOGGER_CONFIG, {optional: true});

  transferLog(level: TransferredLogLevel, message: string, trace: string, meta?: object): void {
    const {url, envName, appName} = this.config ?? {};
    if (!url) {
      return;
    }

    this.http
      .post(url, {
        level,
        message,
        meta: {
          timestamp: new Date().toISOString(),
          environment: envName ?? 'unknown',
          appName: appName ?? 'app/frontend',
          trace,
          ...meta,
        },
      } satisfies TransferredLog)
      .pipe(catchError(() => EMPTY))
      .subscribe(); // fire-and-forget, silently swallow errors
  }
}
